export enum VisibilityStatus {
  PUBLIC = 'public',
  HIDDEN = 'hidden',
}
